import {
	LinkTypes,
	StoryblokRichTextNode,
	StoryblokRichTextNodeResolver,
} from '@storyblok/richtext';

// Inspired by https://github.com/storyblok/monoblok/blob/main/packages/richtext/src/richtext.ts#L171
export function prependInternalLinkResolver(
	prependLink: string,
): StoryblokRichTextNodeResolver {
	return (node: StoryblokRichTextNode, context) => {
		const { linktype, href, anchor, ...rest } = node.attrs || {};

		let finalHref = '';
		switch (linktype) {
			case LinkTypes.ASSET:
			case LinkTypes.URL:
				finalHref = href;
				break;
			case LinkTypes.EMAIL:
				finalHref = `mailto:${href}`;
				break;
			case LinkTypes.STORY:
				finalHref = prependLink + href;
				if (anchor) {
					finalHref = `${finalHref}#${anchor}`;
				}
				break;
			default:
				finalHref = href;
				break;
		}
		const attributes: Record<string, unknown> = { ...rest };
		if (finalHref) {
			attributes['href'] = finalHref;
		}
		return context.render('a', attributes, node.text);
	};
}
